'use strict';

import angular from 'angular';

export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
      $stateProvider
        .state('main.favoris', {
          url: '/favoris',
          templateUrl: 'app/favoris/favoris.html',
          controller: 'FavorisController',
          controllerAs: 'vm'
        });
    }]);
